import { z } from "zod"

import { LabelType } from "@/graphql/codegen/graphql"

export const materialRequirementsFormSchema = z.object({
  allowsRecertifiedMaterial: z.boolean(),
  prefersNewestMaterial: z.boolean(),
  shelfLifeRequired: z.boolean(),
  shelfLifeRequirement: z.preprocess(
    (val) => (val === "" || val === null || val === undefined ? undefined : val),
    z.coerce
      .number()
      .min(0, "Shelf life requirement must be 0 or greater")
      .max(100, "Shelf life requirement cannot exceed 100%")
      .optional()
  ),
  changeApprovalRequired: z.boolean(),
  prefersFewestLots: z.boolean(),
  labelConfiguration: z.array(z.nativeEnum(LabelType)).max(8, "Shipping Label cannot exceed 8 selections").nullable(),
})
